import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import Empty from "./Empty";
import Spinner from "../micro/Spinner";
import { terms } from "../../services/services";

class TermsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      terms: null,
    };
  }

  componentDidMount() {
    this.getTerms();
  }
  getTerms() {
    terms(this.props.termId).then((items) => {
      items && this.setState({ terms: items });
    });
  }
  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.props.termsModal}
          toggle={() => this.props.changeModal(!this.props.termsModal)}
        >
          <ModalBody className="row mx-0 p-4">
            {this.state.terms ? (
              <div className="col-12 px-0 py-2">
                {this.state.terms.length === 0 ? (
                  <Empty />
                ) : (
                  this.state.terms.map((term, t) => (
                    <div>
                      <h2 className="fw-bold fs-4">{term.title}</h2>
                      <p
                        className="fw-bold text-muted"
                        style={{
                          whiteSpace: "pre-wrap",
                          lineHeight: "1.7em",
                        }}
                      >
                        {term.des}
                      </p>
                    </div>
                  ))
                )}
              </div>
            ) : (
              <Spinner />
            )}
            <button
              onClick={() => this.props.changeModal(!this.props.termsModal)}
              className="btn rounded28 py-2 w-100 fw-bold bg-color-main text-center text-white"
            >
              متوجه شدم
            </button>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default TermsModal;
